(async () => {
  const {
    updateURLParams,
    historyPush,
    parseHTML,
    loadScript,
    loadStyle
  } = await import(window.theme.modules.utils);
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('product-bundle-form', class extends baseComponent.default {
    elements = {
      form: 'form',
      addButton: '[data-add-button]',
      buyButton: '[data-buy-button]',
      content: '[data-content]',
      price: '[data-bundle-price]', 
      originalPrice: '[data-bundle-original-price]',
      productSelection: '.bundle-selection__line [data-bundle-select]',
      sezzlePrice: '.sezzle_price',
      bundleSwiperContainer: '[data-bundle-swiper]',
      qty: '[name="quantity"]'
    };

    async render() {
      await this._initSwiper();

      this.swiper = [];
      const allSwipers = this.querySelectorAll(this.elements.bundleSwiperContainer);
      allSwipers.forEach((slider, index) => {
        this.swiper[index] = new window.Swiper(slider, {
          slidesPerView: 4.1,
          simulateTouch: true,
          navigation: {
            nextEl: slider.querySelector('.swiper-button-next'),
            prevEl: slider.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            640: {
              slidesPerView: 4
            }
          }
        });
      });

      this.discount = parseInt(this.dataset.bundleDiscount) || 0;
      this.selections = this.querySelectorAll(this.elements.productSelection);

      // Initialize optional lines as active
      this.querySelectorAll('.bundle-selection__line-optional').forEach((line) => {
        line.dataset.optionalActive = 'true';
      });

      this.selections.forEach(($selection) => {
        $selection.addEventListener('click', this._onSelection.bind(this, $selection));
      });

      this.$qty.addEventListener('change', () => {
        this._updatePrice();
      });

      this._updateSelectionPrices();
      this._updatePrice();

      if (this.hasAttribute('cart-popup'))
        this.$addButton.addEventListener('click', this._handleSubmit.bind(this));
    };

    async _initSwiper() {
      await loadStyle(window.theme.styles.Swiper);
      await loadScript(window.theme.scripts.Swiper, 'swiper');
    };

    _isLineActive(line) {
      if (!line) return false;
      if (line.dataset.optionalActive === 'false') return false;
      return true;
    }

    _onSelection(selection) {
      let $selectionLine = selection.closest('.bundle-selection__line');
      let isOptional = $selectionLine.hasAttribute('data-optional');
      let isNoneOption = selection.hasAttribute('data-bundle-none');

      // Clicking the "None" option on an optional line
      if (isNoneOption && isOptional) {
        let $activedSelection = $selectionLine.querySelector('.bundle-selection__item.actived');
        if ($activedSelection) {
          $activedSelection.classList.remove('actived');
        }
        selection.classList.add('actived');
        $selectionLine.dataset.optionalActive = 'false';
        $selectionLine.classList.add('bundle-selection__line-disabled');
        // Hide gallery image for this line
        let lineID = $selectionLine.dataset.bundleId;
        var wrapper = document.querySelector(`.bundle_img_wrapper[data-bundle-id="${lineID}"]`);
        if (wrapper) {
          wrapper.classList.remove('gallery-active');
          wrapper.style.display = 'none';
        }
        this._updateSelectionPrices();
        this._updatePrice();
        return;
      }

      // Clicking an already active item does nothing (use "None" to deselect)
      if (selection.classList.contains('actived')) {
        return;
      }

      // Clicking a different item
      let $activedSelection = $selectionLine.querySelector('.bundle-selection__item.actived');
      if ($activedSelection) {
        $activedSelection.classList.remove('actived');
      }

      selection.classList.add('actived');

      // Re-activate optional line when selecting a new item
      if (isOptional) {
        $selectionLine.dataset.optionalActive = 'true';
        $selectionLine.classList.remove('bundle-selection__line-disabled');
      }

      // Update gallery image
      let lineID = $selectionLine.dataset.bundleId;
      let imgUrl = selection.dataset.imageUrl;
      var targetWrapper = document.querySelector(`.bundle_img_wrapper[data-bundle-id="${lineID}"]`);
      if (targetWrapper) {
        // Show the gallery image back (in case it was hidden by "None")
        targetWrapper.style.display = '';
        var targetImg = targetWrapper.querySelector('img');
        if (targetImg) {
          targetImg.src = imgUrl;
          targetImg.dataset.src = imgUrl;
        }
      }

      // Highlight this gallery image as the last interacted
      this._setGalleryActive(lineID);

      this._updateSelectionPrices();
      this._updatePrice();
    }

    _setGalleryActive(bundleId) {
      document.querySelectorAll('.bundle_img_wrapper.gallery-active').forEach((el) => {
        el.classList.remove('gallery-active');
      });
      var wrapper = document.querySelector(`.bundle_img_wrapper[data-bundle-id="${bundleId}"]`);
      if (wrapper) wrapper.classList.add('gallery-active');
    }

    _updateSelectionPrices() {
      let bundleLines = this.querySelectorAll('.bundle-selection__line-slider');

      bundleLines.forEach((bundleLine) => {
        let selectedProduct = bundleLine.querySelector('.bundle-selection__item.actived');
        if (!selectedProduct) return;
        const allItems = bundleLine.querySelectorAll('.bundle-selection__item:not(.actived)');
        const price = parseInt(selectedProduct.dataset.price);
        selectedProduct.querySelector('.bundle-selection__product-price').innerHTML = formatMoney(price);

        allItems.forEach((item) => {
          let itemPrice = parseInt(item.dataset.price);
          let priceDiff = itemPrice - price;

          if (priceDiff > 0) {
            item.querySelector('.bundle-selection__product-price').innerHTML = '+' + formatMoney(priceDiff);
          } else if (priceDiff == 0) {
            item.querySelector('.bundle-selection__product-price').innerHTML = '';
          } else {
            item.querySelector('.bundle-selection__product-price').innerHTML = '-' + formatMoney(-priceDiff);
          }
        });
      });
    }

    _getActiveSelections() {
      return Array.from(this.selections).filter((selection) => {
        if (!selection.classList.contains('actived')) return false;
        if (selection.hasAttribute('data-bundle-none')) return false;
        let line = selection.closest('.bundle-selection__line');
        return this._isLineActive(line);
      });
    }

    _getSelectedPrice() {
      let $selections = this._getActiveSelections();
      if ($selections.length === 0) return 0;
      return $selections.reduce((sum, s) => sum + parseFloat(s.dataset.price), 0);
    }

    _updatePrice() {
      let price = this._getSelectedPrice();
      let times = (100 - this.discount) / 100;
      let discountedPrice = price * times;

      this.$price.innerHTML = formatMoney(discountedPrice);
      this.$originalPrice.innerHTML = formatMoney(price);
      this.$sezzlePrice.innerHTML = formatMoney(discountedPrice / 4);
      this._updateButtonPrice(discountedPrice * this.$qty.value);
    }

    _updateButtonPrice(price) {
      this.$addButton.querySelector('.\\#button-text').innerHTML = window.theme.i18n.addToCart + ' - ' + formatMoney(price);
    }

    _handleSubmit(e) {
      e.preventDefault();
      const productUrl = this.getAttribute('product-url');
      const productImage = this.dataset.productImage;
      const productTitle = this.dataset.productTitle;

      let $selections = this._getActiveSelections();
      let qty = this.$qty.value;
      let properties = [];
      let uniqueBundleId = productUrl;

      // First active selection is the bundle parent
      let bundleParentId = $selections.length > 0 ? $selections[0].dataset.variantId * 1 : 0;

      // Build properties list from all active selections
      $selections.forEach((selection) => {
        uniqueBundleId += '---' + selection.dataset.variantId;
        properties.push({
          title: selection.dataset.productTitle,
          variantTitle: selection.dataset.variantTitle || '',
          image: selection.dataset.imageUrl,
          id: selection.dataset.variantId * 1
        });
      });

      var bundleProperties = {
        _bundle_id: uniqueBundleId,
        _bundle_parentId: bundleParentId,
        _bundle_url: productUrl,
        _bundle_title: productTitle,
        _bundle_image: productImage,
        _bundle_items: properties,
        _bundle_discount: this.discount
      };

      // Build cart items — one per active selection
      let items = $selections.map((selection) => ({
        quantity: qty,
        id: selection.dataset.variantId * 1,
        properties: bundleProperties
      }));

      this.formData = JSON.stringify({items: items});
      this._addToCartRequest();
    }

    async _addToCartRequest() {
      this._setLoading(true);

      try {
        const response = await fetch(`${window.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: this.formData
        });

        if (!response.ok) {
          console.log('Failed to add items to cart');
          throw new Error('Failed to add items to cart');
        }

        const data = await response.json();
        if (data.status === 422) {
          if (!data.description) {
            console.warn(data);
            return;
          }
          this._setLoading(false);
        } else {
          this.trigger('updateCart', {
            callback: () => {
              this._setLoading(false);

              if(this.cartSection) {
                this.cartSection.update();
              } else {
                this.trigger('openPopup', { target: 'CART' });
              }
            }
          })
        }

      } catch (error) {
        console.error('Error adding items:', error);
        this._setLoading(false);
      }
    }

    _setLoading(status) {
      status
        ? this.$addButton.setAttribute('loading', '')
        : this.$addButton.removeAttribute('loading');
    }
  });
})();
